export default function SectionTitle({ eyebrow, title, description, center = false, testId }) {
    return (
        <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl`} data-testid={testId}>
            {eyebrow && (
                <div className={`text-[11px] uppercase tracking-[0.28em] text-gold mb-4 flex items-center gap-3 ${center ? "justify-center" : ""}`}>
                    <span className="divider-gold" /> {eyebrow}
                </div>
            )}
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-navy">
                {title}
            </h2>
            {description && (
                <p className={`mt-5 text-navy/70 text-base leading-relaxed ${center ? "" : "max-w-2xl"}`}>
                    {description}
                </p>
            )}
        </div>
    );
}
